// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusDoneIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="m8.25 12.29 2.96 2.96 4.5-6.75"
    />
  </svg>,
  "StatusDone",
);
export default StatusDoneIcon;
